import { render, staticRenderFns } from "./HT_groupaccident.vue?vue&type=template&id=380021da&scoped=true"
import script from "./HT_groupaccident.vue?vue&type=script&lang=js"
export * from "./HT_groupaccident.vue?vue&type=script&lang=js"
import style0 from "./HT_groupaccident.vue?vue&type=style&index=0&id=380021da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380021da",
  null
  
)

export default component.exports